// extracted by mini-css-extract-plugin
module.exports = {"availability":"Availability_availability__i5tVH"};